import { env } from '../env/env';
const ENVIRONMENT = env.getString('ENV') || '';
const CAPFIN_DOMAIN_PREFIX = ENVIRONMENT === 'production' ? '' : `${ENVIRONMENT}-`;
let CAPFIN_PROPOSAL_URL;
if (process.env.NODE_ENV === 'development') {
    CAPFIN_PROPOSAL_URL = 'http://localhost:8000/capfin';
}
else {
    CAPFIN_PROPOSAL_URL =
        ENVIRONMENT === 'production' ? 'https://capital.c2fo.com/' : 'https://capital-non-prod-ods.c2fo.com';
}
// will use eventually:
const CAPFIN_REACT_APP_DOMAIN = process.env.NODE_ENV === 'development'
    ? 'http://localhost:4444'
    : `https://${CAPFIN_DOMAIN_PREFIX}capfin-app.c2fo.com`;
const CAPFIN_API_BASE_URL = process.env.NODE_ENV === 'development'
    ? 'http://localhost:8081/v2/tpf-api'
    : `https://${CAPFIN_DOMAIN_PREFIX}tpf-supplier-api.c2fo.com/v2/tpf-api`;
export const capfinConfig = {
    CAPFIN_PROPOSAL_URL,
    CAPFIN_APPLY_NOW_URL: `${CAPFIN_REACT_APP_DOMAIN}/onboarding`,
    CAPFIN_API_BASE_URL,
    CAPFIN_REACT_APP_DOMAIN,
};
//# sourceMappingURL=capfinConfig.js.map